<template>
  <section id="challenge-how-to-play" class="pt-4 pb-5 text-black px-4">
    <SectionTitleHeader :title="$t('message.how-to-play')" color="general-knowledge" class="pt-4 mb-5" />
    <p class="text-white section-subtitle text-start" data-aos="fade-left" v-html="$t('message.challenge-how-to-play-1')"></p>
    <p class="text-white section-subtitle text-start" data-aos="fade-left" v-html="$t('message.challenge-how-to-play-2')"></p>
    <div class="chat-area d-flex flex-column">
      <Ballon :text="$t('message.challenge-demo-1')" class="mb-4 max-width" />
      <Ballon :text="$t('message.challenge-demo-2')" class="mb-4 to-right font-weight-bold align-self-end" :answer="true" style="width: 120px" />
      <Ballon :text="$t('message.challenge-demo-3')" class="mb-4 max-width" style="width: 260px" />
    </div>
    <p class="text-white section-subtitle text-start" data-aos="fade-left" v-html="$t('message.challenge-how-to-play-3')"></p>
  </section>
</template>
<script>
import Ballon from '@/components/Ballon.vue';
import SectionTitleHeader from '@/components/SectionTitleHeader.vue';

export default {
  components: { Ballon, SectionTitleHeader }
};
</script>
<style lang="scss" scoped>
@import '@/assets/custom-vars/_colors.scss';

#challenge-how-to-play {
  background: $gradient-literature;
}
</style>
